<template>
   <div>
    <div class="row">
      <div class="login-form-col">
        <div class="container login-form mx-auto">
          <img src=".././assets/images/Logo.svg" alt="">
          <form class="form-set" @submit.prevent="handleSubmit">
            <div class="form-container">
              <p style="color:red" v-text="error"></p>
              <div class="form-group">
                <label for="username">Username</label>
                <input type="text" class="form-control" id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  placeholder="Enter username" v-model="email">
              </div>
              <div class="form-group">
                <label for="exampleInputPassword1">Password</label>
                <input type="password" class="form-control"
                  id="exampleInputPassword1" placeholder="Password"
                  v-model="password">
              </div>
              <router-link to="/reset-password">
                Forgot password?
              </router-link>
              <a href="mailto:support@konnect-us.com">Contact support</a>
            </div>
            <button type="submit" class="btn btn-primary btn-login">LOGIN</button>
          </form>
        </div>
      </div>
      <div style="float:right; position: absolute; right: 0; height: 70vh;">
        <img src=".././assets/images/img1@2x-no-bg-5.png" height="140%" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Login',
    data() {
      return {
        email: '',
        password: '',
      };
    },
    mounted() {
      this.showAlerts();
    },
    computed: {
      error() {
        return this.$store.state.auth.error;
      },
      authorized() {
        return this.$store.state.auth.authorized;
      },
    },
    methods: {
      showAlerts() {
        if (this.$session.has('success')) {
          this.$snotify.success(this.$session.get('success'));
        }

        this.$session.remove('success');

        if (this.$session.has('error')) {
          this.$snotify.error(this.$session.get('error'));
        }

        this.$session.remove('error');
      },
      handleSubmit() {
        const data = {
          email: this.email,
          password: this.password,
        };

        this.$store.dispatch('auth/login', data)
          .then(() => {
            // Get application settings
            this.$store.dispatch('settings/get');
            // Redirect to dashboard
            if(this.$store.state.mobile) {
              this.$router.push('/attendance/tracking');
            } else {
              this.$router.push('/video/dashboard/cams');
            }
          });
      },
    },
  };
</script>

<style scoped>
  .col-7 {
    z-index: 0;
  }
  .col-5 {
    z-index: 1;
  }
</style>
